import MaterialTable from "material-table";
import tableicons from "../tableicons";
import React from "react";
import {ValidacionConteoResources} from "../endpoints";
import SnackbarAlert from "../components/SnackbarAlert";
import Typography from "@material-ui/core/Typography";

class ResumenValidacion extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            valores : [],
        }
    }

    getValoresValidacion = () =>{
        ValidacionConteoResources.getResumen().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({valores:result})
        }).catch(error=> {
            console.log(error)
        });
    }

    componentDidMount() {
        this.getValoresValidacion();
    }

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>
                    Resumen validación
                </Typography>
                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                            nRowsSelected: "{0} registro(s) seleccionado(s)"
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        },
                        pagination:{
                            firstAriaLabel: 0,
                        },
                        header: {
                            actions: 'Acciones',
                            sizeActions:"large"
                        },
                    }}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense",
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                    }}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                    isLoading={this.state.cargando}
                    icons={tableicons}
                    title= ""
                    data={this.state.valores}
                    columns={[
                        { title: 'Material', field: 'id',
                            editable:"never",
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Descripcion', field: 'descripcion',
                            editable:"never",
                            cellStyle: {
                                width: 400,
                                maxWidth: 400,
                            },
                            headerStyle: {
                                width: 400,
                                maxWidth: 400
                            }
                        },
                        { title: 'UN', field: 'un',
                            editable:"never",
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Cantidad teo.', field: 'teo',
                            editable:"never",
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.teo)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.teo).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Cantidad inv.', field: 'inv',
                            editable:"never",
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.inv)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.inv).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Diferencia', field: 'dif',
                            editable:"never",
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.dif)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.dif).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Inv.Imp.', field: 'invimp',
                            editable:"never",
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.invimp)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.invimp).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Teo.Imp.', field: 'teoimp',
                            editable:"never",
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.teoimp)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.teoimp).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Dif. importe', field: 'difimp',editable:'never',  type: 'numeric',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.difimp)),
                            customSort: (a, b) => Math.abs(a.difimp) - Math.abs(b.difimp),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.difimp).indexOf(term) !== -1),
                        },
                    ]}
                />
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default ResumenValidacion;